import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MimeTypeService {

  constructor() {
  }

  static getImageMimeTypeStatic(fileBase64: string): string {
    const file = atob(fileBase64);
    let mimeType = 'image/jpeg';
    if (file.substring(0, 3) === 'GIF') {
      mimeType = 'image/gif';
    }
    if (file.substring(0, 4) === '<svg' || file.substring(0, 4) === '<?xm') {
      mimeType = 'image/svg+xml';
    }
    if (file.substring(1, 4) === 'PNG') {
      mimeType = 'image/png';
    }
    return mimeType;
  }

  getImageMimeType(fileBase64: string): string {
    return MimeTypeService.getImageMimeTypeStatic(fileBase64);
  }

}
